var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"grow"}},[_c('div',{staticClass:"loading-bar",style:(_vm.animationStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }